const DocumentPreparationSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M12.125 6.41C11.915 6.41 11.75 6.245 11.75 6.035V3.125C11.75 2.915 11.585 2.75 11.375 2.75H4.625C4.415 2.75 4.25 2.915 4.25 3.125V4.625C4.25 4.835 4.085 5 3.875 5C3.665 5 3.5 4.835 3.5 4.625V3.125C3.5 2.5025 4.0025 2 4.625 2H11.375C11.9975 2 12.5 2.5025 12.5 3.125V6.035C12.5 6.245 12.335 6.41 12.125 6.41Z"
        fill="#333333"
        stroke="#333333"
        strokeWidth="0.2"
      />
      <path
        d="M12.875 14H3.125C2.5025 14 2 13.4975 2 12.875V5.375C2 4.7525 2.5025 4.25 3.125 4.25H6.6875C6.8075 4.25 6.92 4.3025 6.9875 4.4L8 5.75H12.875C13.4975 5.75 14 6.2525 14 6.875V12.875C14 13.4975 13.4975 14 12.875 14ZM3.125 5C2.915 5 2.75 5.165 2.75 5.375V12.875C2.75 13.085 2.915 13.25 3.125 13.25H12.875C13.085 13.25 13.25 13.085 13.25 12.875V6.875C13.25 6.665 13.085 6.5 12.875 6.5H7.8125C7.75408 6.50122 7.69623 6.48821 7.64396 6.46207C7.5917 6.43594 7.54658 6.39747 7.5125 6.35L6.5 5H3.125Z"
        fill="#333333"
        stroke="#333333"
        strokeWidth="0.2"
      />
      <path
        d="M4 2.5C4 2.22386 4.22386 2 4.5 2H11.5C11.7761 2 12 2.22386 12 2.5V5.5C12 5.77614 11.7761 6 11.5 6H8.20711C8.0745 6 7.94732 5.94732 7.85355 5.85355L6.64645 4.64645C6.55268 4.55268 6.4255 4.5 6.29289 4.5H4.5C4.22386 4.5 4 4.27614 4 4V2.5Z"
        fill="#333333"
      />
      <path
        d="M10.5 9.9974H5.08333M10.5 9.9974L8.83333 8.33073M10.5 9.9974L8.83333 11.6641"
        stroke="#333333"
        strokeWidth="0.833333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DocumentPreparationSvg;
